export var colorTheme = {
    primary: {
        darker: "#154D00",
        DEFAULT: "#8BBF56",
        lighter: "#668C3F",
        lightest: "#E6F6D1",
    },
    warning: "#F9CB6D",
    "warning-darker": "#F9CB6D",
    error: "#F56A48",
};
